import React from "react";
import "./LandingPage.css";

const LandingPage = () => {


  return (
    <main className="landing-page" dir="rtl">

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="landing-hero">

        <div className="landing-hero-glow landing-glow-one"></div>
        <div className="landing-hero-glow landing-glow-two"></div>

        <div className="landing-hero-inner">

          <div className="landing-label">
            <span className="landing-label-line"></span>
ש.מ הובלות ומנופים
          </div>

          <h1 className="landing-title">
            הובלות ומנופים
            <span>ברמה אחרת</span>
          </h1>

          <p className="landing-subtitle">
            פתרונות מקצועיים להובלה, הרמה ושינוע
            <strong> בפריסה רחבה ובביצוע מדויק.</strong>
          </p>

          <p className="landing-description">
            אנו מספקים שירותי הובלה, מנופים, הרמות ושינוע
            ללקוחות פרטיים ועסקיים, קבלנים וחברות.
            כל עבודה מתבצעת תוך הקפדה על בטיחות,
            מקצועיות, אמינות והתאמה מלאה לתנאי השטח.
          </p>

          <div className="landing-buttons">

            <a
              href="tel:0506615262"
              className="landing-primary-button"
            >
              <span>📞</span>
              התקשרו עכשיו
            </a>

        

          </div>

        </div>

        <div className="landing-scroll-indicator">
          <span></span>
          גללו למטה
        </div>

      </section>


      {/* =====================================================
          TRUST
      ===================================================== */}

      <section className="landing-trust">

        <div className="landing-trust-inner">

          <div className="trust-item">
  
            <div>
              <h3>מקצועיות</h3>
              <p>ביצוע מדויק לכל סוג עבודה</p>
            </div>
          </div>

          <div className="trust-divider"></div>

          <div className="trust-item">
        
            <div>
              <h3>בטיחות</h3>
              <p>עבודה אחראית בהתאם לתנאי השטח</p>
            </div>
          </div>

          <div className="trust-divider"></div>

          <div className="trust-item">
       
            <div>
              <h3>אמינות</h3>
              <p>שירות אישי ועמידה בזמנים</p>
            </div>
          </div>

        </div>

      </section>


      {/* =====================================================
          SERVICES
      ===================================================== */}

      <section className="content">

        <div className="content-inner">

    

          <h2>
            פתרונות הובלה ושינוע
            <span>לכל צורך</span>
          </h2>

          <p className="content-intro">
            ש.מ הובלות ומנופים מעניקה מגוון פתרונות מקצועיים
            בתחום ההובלות, המנופים והשינוע
          </p>


          <ul className="services-list">

            <li>
              <span className="service-number">01</span>
<div className="service-text">
  <strong>הובלת חומרי בניין</strong>
  <small>הובלה בטוחה ומקצועית של חומרי בניין לאתרי עבודה</small>
</div>

              <span className="service-check">✓</span>
            </li>

            <li>
              <span className="service-number">02</span>
              <div className="service-text">
                <strong>הובלות עם מנוף</strong>
                <small>הובלה והרמה גם בתנאי שטח מורכבים</small>
              </div>
              <span className="service-check">✓</span>
            </li>

            <li>
              <span className="service-number">03</span>
              <div className="service-text">
                <strong>שירותי מנוף והרמה</strong>
                <small>מנופי הרמה וסלי הרמה למגוון עבודות</small>
              </div>
              <span className="service-check">✓</span>
            </li>

            <li>
              <span className="service-number">04</span>
              <div className="service-text">
                <strong>שינוע והובלת ציוד כבד</strong>
                <small>הובלה בטוחה ומקצועית של ציוד ומטענים</small>
              </div>
              <span className="service-check">✓</span>
            </li>

            <li>
              <span className="service-number">05</span>
              <div className="service-text">
                <strong>הרמת ריהוט וציוד למקומות מורכבים</strong>
                <small>פתרונות הרמה במקומות שבהם הגישה מוגבלת</small>
              </div>
              <span className="service-check">✓</span>
            </li>

            <li>
              <span className="service-number">06</span>
              <div className="service-text">
                <strong>פתרונות הובלה בהתאמה אישית</strong>
                <small>התאמת השירות לסוג העבודה ולתנאי השטח</small>
              </div>
              <span className="service-check">✓</span>
            </li>

          </ul>


          <p className="highlight">
            אנחנו כאן כדי לבצע את העבודה בצורה מקצועית,
            בטוחה ויעילה – מההובלה הראשונה ועד הפריט האחרון
          </p>

        </div>

      </section>



      {/* =====================================================
          ABOUT / PROMISE
      ===================================================== */}

      <section className="landing-promise">

        <div className="promise-box">

  

          <div className="promise-content">

            <div className="landing-section-label">
              למה ש.מ הובלות ומנופים ?

            </div>


            <h2>
              אנחנו מאמינים שעבודה טובה מתחילה בתכנון נכון.
              לכן אנחנו מתאימים את פתרון ההובלה או ההרמה
              לסוג המטען, לתנאי השטח ולצרכים של הלקוח !
            </h2>

          

          </div>

        </div>

      </section>


  
    </main>
  );
};

export default LandingPage;